<!-- 编辑商品清单-->
<template>
    <div class="business-content-main goodsMerge">
        <div>
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <div class="section-title">
                <div class="flex">
                    <div style="color: red;font-size: 14px;">
                        商品进行合并操作后，被合并商品的库存数将叠加到被保留商品。被合并商品关联的商品数据将会被删除，请谨慎操作（包括库存商品数、相关标签信息），被合并商品的编码将合并到被保留的商品互换码中，其他信息将被删除。
                    </div>
                </div>
                <div>
                    <el-button size="small" class="search-btn btn-primary" v-if="[1, 2, 3].includes(type)" @click="submitForm(0)" :disabled="saving">保存清单</el-button>
                    <el-button size="small" class="search-btn btn-primary" v-if="[1, 2].includes(type)" @click="submitForm(1)" :disabled="saving">提交清单</el-button>
                </div>
            </div>
        </div>

        <div id="infinite-list">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteTableHeight"
                :checkboxConfig="{ highlight: false }"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                :row-style="setRowStyle"
                highlight-current-row
                show-overflow="tooltip"
                :row-class-name="tableRowClassName"
                @row-click="rowClick"
                @cell-click="cellClick"
            >
                <ux-table-column field="KeepAPCode" title="被保留编码" min-width="50" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.KeepAPCode }]">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.KeepGoodsId)" />
                            <span>{{ row.KeepAPCode ? row.KeepAPCode : '请点击选中被保留编码' }}</span>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="kcode"
                            :loading="codeForm.loading"
                            default-first-option
                            size="small"
                            v-model="scope.row.KeepAPCode"
                            value-key="APCode"
                            filterable
                            :disabled="dataReadonly||scope.row.IsMerged"
                            clearable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, scope.rowIndex, 'keep')"
                            @visible-change="apCodeVisibleChange($event)"
                            @keyup.enter.native="addItem(true)"
                            :remote-method="
                                query => {
                                    searchCode(query, scope.rowIndex);
                                }
                            "
                            style="width: 100%"
                            popper-class="el-select-style-gray"
                            v-select-scroll-more="searchCodeLoad"
                        >
                            <el-option
                                v-for="optionItem in codeList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="optionItem.APCode"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name in-one-line">
                                        {{ optionItem.AutoSerise }}
                                    </div>
                                    <div class="project-Name">
                                        {{ optionItem.GoodCode }}
                                    </div>
                                </div>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="KeepGoodsName" title="被保留商品名称" min-width="50" resizable>
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.KeepGoodsName }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="KeepAutoSerise" title="被保留商品车型" min-width="50" resizable>
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.KeepAutoSerise }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="KGCount" title="合并前库存" min-width="50">
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.KGCount }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="DelAPCode" title="被合并编码" min-width="50" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.DelAPCode }]">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.DelGoodsId)" />
                            <span>{{ row.DelAPCode ? row.DelAPCode : '请点击选中被合并编码' }}</span>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="dcode"
                            :loading="codeForm_del.loading"
                            default-first-option
                            size="small"
                            v-model="scope.row.DelAPCode"
                            value-key="APCode"
                            :disabled="dataReadonly||scope.row.IsMerged"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, scope.rowIndex, 'del')"
                            @visible-change="apCodeVisibleChange_del($event)"
                            @keyup.enter.native="addItem(true)"
                            :remote-method="
                                query => {
                                    searchCode_del(query, scope.rowIndex);
                                }
                            "
                            style="width: 100%"
                            popper-class="el-select-style-gray"
                            v-select-scroll-more="searchCodeLoad_del"
                        >
                            <el-option
                                v-for="optionItem in codeList_del"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="optionItem.APCode"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name in-one-line">
                                        {{ optionItem.AutoSerise }}
                                    </div>
                                    <div class="project-Name">
                                        {{ optionItem.GoodCode }}
                                    </div>
                                </div>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="DelGoodsName" title="被合并商品名称" min-width="50" resizable>
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.DelGoodsName }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="DelAutoSerise" title="被合并商品车型" min-width="50" resizable>
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.DelAutoSerise }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="KGCount" title="合并后库存" min-width="50">
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.IsMerged ? scope.row.KGCount + scope.row.DGCount : '-' }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" min-width="150" resizable>
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate">
                            <i v-if="showIconDelete(row)" class="el-icon-delete" title="移除" @click="delItem(rowIndex)"></i>
                            <i v-if="showIconAdd(rowIndex)" class="el-icon-plus" title="添加" @click="addItem(true)"></i>
                            <i v-if="showFinBtn(rowIndex)" class="pl10" style="color: gray;">已合并</i>
                            <i v-if="showMergeBtn(row)" class="pl10" style="color: red;" :disabled="saving" @click="mergeGoods(row)">确认合并</i>
                            <i v-if="showlableBtn()" class="pl10" style="color: orange;" @click="showLabels(row)">标签数据</i>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--   标签信息     -->
        <el-dialog :close-on-click-modal="false" title="查看标签数据" :visible.sync="lableVisible" width="1100px">
            <div v-if="lableVisible">
                <labels :dialogFormVisible="lableVisible" :GoodsData="GoodsData" @closeDialog="closeAPMsgDialog"></labels>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import APMsg from '@/components/common/APMsg';
import labels from '@/components/business/goods/goodsLabelsMerge';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        APMsg,
        breadcrumb,
        labels
    },
    data() {
        return {
            dataReadonly: false,
            needConfirm: true,
            dataStorageName: 'AddMultiSuPurOrders_dataList',
            EntpTempGoodsIdEdit: '',
            APMsgVisible: false,
            lableVisible: false,
            saving: false,
            loading: false,
            Limit: 10,
            codeList: [],
            codeList_del: [],
            dataList: [],
            type: 0, //0查看  1新增  2 编辑 3修改 4确认合并
            pageTitle: '',
            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            EntpCusId: '',
            EntpCusName: '',
            dataindex: 0,
            currentRow: {},
            submitData: {},
            // 用于汽配编码列表，分页搜索功能
            codeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: '',
                loading: false
            },
            codeForm_del: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: '',
                loading: false
            },
            GoodsData: {}
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        let that = this;
        document.addEventListener('keydown', that.handleKeyEvent);
    },
    mounted() {
        this.submitData.OrderId = this.$route.query.id;
        this.type = Number(this.$route.query.type);
        switch (this.type) {
            case 0:
                this.pageTitle = '查看合并清单';
                this.dataReadonly = true;
                break;
            case 1:
                this.pageTitle = '新增合并清单';
                break;
            case 2:
                this.pageTitle = '编辑合并清单';
                break;
            case 3:
                this.pageTitle = '修改合并清单';
                break;
            case 4:
                this.pageTitle = '确认合并';
                this.dataReadonly = true;
                break;
        }
        if (this.type == 1) {
            this.addItem(false);
        } else {
            this.getOrderDetail();
        }

        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);
        window.onresize = () => {
            this.resetHeight();
        };
        setTimeout(() => {
            this.resetHeight();
        }, 0);
    },
    computed: {
        // 列表高度
        infiniteTableHeight() {
            let bottomHeight = 38;
            return this.infiniteListHeight - bottomHeight;
        },
        showIconDelete() {
            return function(row) {
                return ![0, 4].includes(this.type) && this.dataList.length !== 1 && !row.IsMerged;
            };
        },
        showIconAdd() {
            return function(rowIndex) {
                return ![0, 4].includes(this.type) && rowIndex + 1 === this.dataList.length;
            };
        },
        showMergeBtn() {
            return function(row) {
                return !row.IsMerged && this.type == 4;
            };
        },
        showFinBtn() {
            return function(row) {
                return row.IsMerged;
            };
        },
        showlableBtn() {
            return function() {
                return ![1, 2].includes(this.type);
            };
        }
    },
    methods: {
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            // if (edit) {
            //     this.getOrderDetail();
            // }
        },

        getOrderDetail() {
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsMergeOrders',
                    data: {
                        Id: this.submitData.OrderId
                    }
                })
                .then(res => {
                    let data = res.data;
                    this.submitData = data;
                    this.dataList = data.DetailList;
                });
        },
        // 提交采购单
        submitForm(action) {
            let that = this;
            if (that.saving) {
                return;
            }
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].KeepAPCode) {
                    that.$util.warningMsg('请选择被保留的商品');
                    return;
                }
                if (!_dataList[i].DelAPCode) {
                    that.$util.warningMsg('请选择被合并的商品');
                    return;
                }
                let sameItems = _dataList.filter(item => item.DelAPCode && item.DelAPCode == _dataList[i].DelAPCode);
                if (sameItems.length > 1) {
                    that.$util.warningMsg(`被合并的商品不能重复【${_dataList[i].DelGoodsName}】，编码为【${_dataList[i].DelAPCode}】`);
                    return;
                }
                _dataList[i].SortNum = i + 1;
            }
            that.submitData.IsSumb = action == 1;
            that.submitData.MergeGoodsList = _dataList;
            that.saving = true;
            let url = '/api/EntpGoods/SaveGoodsMergeOrder';
            if (that.type == 3) url = '/api/EntpGoods/SaveGoodsMergeOrderAfterSubmit';
            that.$util
                .axiosPost({
                    url: url,
                    data: that.submitData
                })
                .then(() => {
                    that.$store.commit('updateNeedRefresh', true);
                    that.needConfirm = false;
                    that.$util.successMsg('保存成功');

                    setTimeout(() => {
                        this.$router.push('/inventoryManage/goods/goodsMergeOrders');
                    }, 2000);
                })
                .catch(() => {
                    that.saving = false;
                });
        },

        mergeGoods(item) {
            let that = this;
            that.$confirm(
                `确认合并操作后，商品【${item.DelAPCode}】将被删除，该商品库存将合并到商品【${item.KeepAPCode}】中，<span style="color:red;">且数据不可逆，是否确认合并？</span>`,
                '提示',
                {
                    confirmButtonText: '确定合并',
                    cancelButtonText: '取消',
                    type: 'warning',
                    noMsg: true,
                    dangerouslyUseHTMLString: true,
                    closeOnClickModal: false,
                    closeOnHashChange: false
                }
            )
                .then(() => {
                    that.saving = true;
                    that.$util
                        .axiosPost({
                            url: `/api/EntpGoods/SubmitMergeGoods?RsId=` + item.RsId
                        })
                        .then(res => {
                            that.$util.successMsg('合并成功');
                            item.IsMerged = true;
                        })
                        .finally(() => {
                            that.$store.commit('updateNeedRefresh', true);
                            that.saving = false;
                        });
                })
                .catch(() => {});
        },
        showLabels(item) {
            this.GoodsData = item;
            this.lableVisible = true;
        },

        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
        },
        // 添加一行
        addItem() {
            let that = this;
            let _dataList = that.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].KeepAPCode) {
                    that.$util.warningMsg('请选择被保留的商品');
                    return;
                }
                if (!_dataList[i].DelAPCode) {
                    that.$util.warningMsg('请选择被合并的商品');
                    return;
                }
            }

            let newGoods = {
                RsId: '',
                KeepGoodsId: '',
                KeepAPCode: '',
                KeepGoodsName: '',
                KeepAutoSerise: '',
                KGCount: 0,
                DelGoodsId: '',
                DelAPCode: '',
                DelGoodsName: '',
                DelAutoSerise: '',
                DGCount: 0,
                Size: '',
                IsMerged: false
            };
            that.dataList.push(newGoods);

            setTimeout(() => {
                that.$refs.infiniteTable.scrollToRow(that.dataList[that.dataList.length - 1]);
                that.$refs.infiniteTable.setActiveRow(that.dataList[that.dataList.length - 1]);
                if (that.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('business-content')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);
        },

        // 编码改变
        codeChange(value, index, obj) {
            let that = this;
            if (!value) {
                return;
            }

            if (obj == 'keep') {
                let _list = this.codeList;
                let item = _list.find(v => v.APCode == value);
                if (item) {
                    var same = that.dataList.find(v => v.DelAPCode == value);
                    if (same) {
                        that.dataList[index].KeepAPCode = '';
                        that.$util.warningMsg('保留与合并的商品不能是同一个');
                        return;
                    }
                    that.dataList[index].KeepAPCode = item.APCode;
                    that.dataList[index].KeepGoodsId = item.EntpTempGoodsId;
                    that.dataList[index].KeepGoodsName = item.GoodName;
                    that.dataList[index].KeepAutoSerise = item.AutoSerise;
                    that.dataList[index].KGCount = item.Inventory;

                    that.$refs[`dcode`].focus();
                }
                return;
            }

            if (obj == 'del') {
                let _list = this.codeList_del;
                let item = _list.find(v => v.APCode == value);
                if (item) {
                    var same1 = that.dataList.find(v => v.KeepAPCode == value);
                    if (same1) {
                        that.dataList[index].DelAPCode = '';
                        that.$util.warningMsg('保留与合并的商品不能是同一个');
                        return;
                    }
                    that.dataList[index].DelAPCode = item.APCode;
                    that.dataList[index].DelGoodsId = item.EntpTempGoodsId;
                    that.dataList[index].DelGoodsName = item.GoodName;
                    that.dataList[index].DelAutoSerise = item.AutoSerise;
                    that.dataList[index].DGCount = item.Inventory;
                    return;
                }
            }
            return;
        },

        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.codeList.length == 0) that.searchCode('');
            }
        },

        // 搜索汽配编码
        searchCode(key, index) {
            if (![undefined].includes(key)) {
                this.codeForm.Page = 1;
                this.codeForm.stopLoad = false;
                this.codeForm.key = key;
                this.codeForm.rowIndex = index;
                this.codeList = [];
            }
            if (this.codeForm.stopLoad) return;
            this.codeForm.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForMergeOrder',
                    data: {
                        APCode: this.codeForm.key,
                        Page: this.codeForm.Page,
                        Limit: this.codeForm.Limit
                    },
                    hideLoading: true
                })
                .then(res => {
                    let that = this;
                    this.codeForm.loading = false;
                    if (!res.data) {
                        if (this.codeForm.Page == 1 && that.codeForm.key) {
                            this.codeList = [];
                        }
                        return;
                    }
                    this.codeForm.stopLoad = res.data.length < this.codeForm.Limit;
                    this.codeList = this.$util.uniqueArr(this.codeList, res.data);
                });
        },
        // 汽配编码列表，加载更多
        searchCodeLoad() {
            if (!this.codeForm.loading) {
                this.codeForm.Page += 1;
                this.searchCode();
            }
        },

        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange_del(event) {
            let that = this;
            if (event) {
                if (that.codeList_del.length == 0) that.searchCode_del('');
            }
        },

        // 搜索汽配编码
        searchCode_del(key, index) {
            if (![undefined].includes(key)) {
                this.codeForm_del.Page = 1;
                this.codeForm_del.stopLoad = false;
                this.codeForm_del.key = key;
                this.codeForm_del.rowIndex = index;
                this.codeList_del = [];
            }
            if (this.codeForm_del.stopLoad) return;
            this.codeForm_del.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForMergeOrder',
                    data: {
                        APCode: this.codeForm_del.key,
                        Page: this.codeForm_del.Page,
                        Limit: this.codeForm_del.Limit
                    },
                    hideLoading: true
                })
                .then(res => {
                    let that = this;
                    this.codeForm_del.loading = false;
                    if (!res.data) {
                        if (this.codeForm_del.Page == 1 && that.codeForm_del.key) {
                            this.codeList_del = [];
                        }
                        return;
                    }
                    this.codeForm_del.stopLoad = res.data.length < this.codeForm_del.Limit;
                    this.codeList_del = this.$util.uniqueArr(this.codeList_del, res.data);
                });
        },
        // 汽配编码列表，加载更多
        searchCodeLoad_del() {
            if (!this.codeForm_del.loading) {
                this.codeForm_del.Page += 1;
                this.searchCode_del();
            }
        },

        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = this.dataList.filter(f => f.DelGoodsId === row.DelGoodsId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },

        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            this.dataindex = row.index;
            this.currentRow = row;
        },
        cellClick(row, column, cell, event) {
            if (column.property === 'EntpCusItem') {
                setTimeout(() => {
                    this.$refs[`custSelect`].focus();
                }, 200);
                return;
            }
            if (column.property === 'APCode') {
                setTimeout(() => {
                    this.$refs[`code`].focus();
                }, 200);
                return;
            }
            if (column.property === 'GoodName') {
                setTimeout(() => {
                    this.$refs[`partsNameSelect`].focus();
                }, 200);
                return;
            }
            if (column.property === 'AutoSeriseItem') {
                setTimeout(() => {
                    this.$refs[`autoSeriseSelect`].focus();
                }, 200);
                return;
            }

            if (['Origin', 'Count', 'Price'].includes(column.property)) {
                return;
            }
        },
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            //下键
            if (key == 40) {
                that.canSearch = true;
                e.preventDefault();

                if (that.dataindex != that.dataList.length - 1) {
                    if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                        that.dataindex++;
                    } else that.dataindex = 0;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.infiniteTable) {
                            that.currentRow = that.$refs.infiniteTable.data[index];
                            that.$refs.infiniteTable.setCurrentRow(that.$refs.infiniteTable.data[index]);
                        }
                    });
                }

                return;
            }
            //上键
            if (key == 38) {
                that.canSearch = true;
                e.preventDefault();
                if (that.dataindex != 0) {
                    that.dataindex--;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.infiniteTable) {
                            that.currentRow = that.$refs.infiniteTable.data[index];
                            that.$refs.infiniteTable.setCurrentRow(that.$refs.infiniteTable.data[index]);
                        }
                    });
                }
                return;
            }
            if (key === 107 || key === 187) {
                that.addItem(false);
            }
            // if (key == 113) {
            //     that.$refs.searchDlg.showSearchItem();
            // }
        }
    }
};
</script>
<style lang="less" scoped>
.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 20px;
    margin-bottom: 20px;
}
.form-main {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}
.form-bottom {
    width: 100%;
    display: flex;
    flex-direction: row;
    div {
        width: 50%;
    }
}
.form-applyzone {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}
.form-account {
    width: 57.7%;
    float: left;
    margin-left: 30px;
    border: 1px dashed #888888;
    border-radius: 10px;
}
.inventory-title {
    line-height: 1.2;
    flex-direction: column;
    > div:nth-child(1) {
        width: 100%;
        border-bottom: 1px solid @border3Color;
    }
    > div:nth-child(2) {
        width: 100%;
        display: flex;
        > div {
            width: 33.33%;
        }
    }
}
.form-section {
    display: flex;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
}
.btn-ctn {
    margin-right: 110px;
    padding: 30px 0;
    text-align: right;
    padding-bottom: 180px;
}
.add-btn {
    position: absolute;
    right: 2%;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 2px;
    z-index: 2;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.table-item {
    height: 50px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
    margin: -1px -1px -1px 0px;
}
.div-table-cell-code {
    position: relative;
    .row-delete {
        position: absolute;
        padding: 1px 6px;
        top: 0;
        right: 0;
        color: #fff;
        background: #ffcc66;
        border-radius: 12.5px;
    }
}
.addresscls {
    display: flex;
    flex-direction: row;
}
.addicon {
    height: 30px;
    margin-left: 10px;
    margin-top: 5px;
}
.operate {
    height: 30px;
    // > i {
    //   margin-top: 8.5px;
    //   margin-right: 10px;
    //   cursor: pointer;
    // }
    display: flex;
    align-items: center;
    .el-icon-delete {
        margin-right: 8px;
        cursor: pointer;
    }
    .el-icon-plus {
        margin-right: 8px;
        cursor: pointer;
    }
    .image-sup {
        width: 27px;
        height: 27px;
        margin-right: 2px;
    }
    .image-cus {
        width: 26px;
        height: 26px;
    }
    .pl10 {
        padding-left: 10px;
        cursor: pointer;
    }
}
.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}
#ap-image-dialog {
    position: absolute;
    top: 10%;
    left: 10%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .image-item-dialog {
        width: 120px;
        height: 120px;
    }

    .el-dialog__body {
        padding: 0 !important;
        overflow: auto;
    }
}
</style>
<style lang="less">
.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 20px;
    }
}
.el-col {
    border-radius: 4px;
}
.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
.goodsMerge {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }
        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 4px 12px 0;
                }
                .operate {
                    padding: 0 12px;
                }
                .text-btn {
                    button {
                        padding-left: 0;
                        padding-right: 0;
                    }
                }
                td {
                    height: 26px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
        .elx-table--footer-wrapper {
            margin-top: 0 !important;

            .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }
    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .special-border {
        height: 100%;
        border-radius: 3px;
        border: 1px solid #ffcc00;
    }
    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }
        .info-icon {
            vertical-align: top;
            margin-top: 2px;
            margin-right: 5px;
        }
    }
    .upperLimitWarning {
        .el-input__inner {
            border: 1px solid #e6a23c;
        }
    }
}
</style>
